// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:30Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import SignRequestDocumentFilterVO from "./types/SignRequestDocumentFilterVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 * Service pro hledání dle filtrů Generated from cz.marbes.qsign.controller.QSignSearchController.
 */
export default class QSignSearchApi {
    /**
     * Vyhledá ID dokumentů požadavků dle předaného filtru
     *
     * @param filterVO filter
     * @return seznam ID
     */
    static searchSignRequestDocuments(filterVO : SignRequestDocumentFilterVO, config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignSearchApi.raw.searchSignRequestDocuments(filterVO, config));
    }

    static raw = {
            searchSignRequestDocuments: function(filterVO : SignRequestDocumentFilterVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/search/signRequest/document`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, filterVO, finalConfig);
            },
    }
}
